    // APP
    import AppStructure from "@/pages/Layout/AppStructure";
    import IVEConfig from "@/config/IVEConfig.js";

    // ADMIN
    import Admin from "@/pages/Admin/Admin";

    // USER
    import User from "@/pages/User/User";

    // TRAINING
    import Training from "@/pages/Admin/Training/Training";
    import DialogsTraining from "@/pages/Admin/Training/DialogicInteraction/DialogsTraining";
    import IntentsListTraining from "@/pages/Admin/Training/DialogicInteraction/IntentsListTraining";
    import IntentDetailsTraining from "@/pages/Admin/Training/DialogicInteraction/IntentDetailsTraining";
    import PluginsTraining from "@/pages/Admin/Training/PluginsManagement/PluginsTraining";
    import PluginsListTraining from "@/pages/Admin/Training/PluginsManagement/PluginsListTraining";
    import PluginDetailsTraining from "@/pages/Admin/Training/PluginsManagement/PluginDetailsTraining";

    // TESTING
    import Testing from "@/pages/Admin/Testing/Testing";
    import DialogsTesting from "@/pages/Admin/Testing/DialogicInteraction/DialogsTesting";
    import Radar from "@/pages/Radar/Radar"

    // HOMEPAGE
    import HomePage from "@/pages/Admin/HomePage/HomePage";
    import ServicesCategoriesDetails from "@/pages/Admin/ServicesCategories/ServicesCategoriesDetails";

    // SERVICES SPLASH SCREEN
    // SETTINGS
    import Settings from "@/pages/Settings/Settings";
    import AccountManagement from "@/pages/Settings/AccountManagement";

    //INNOVATION
    import UploadStartups from "@/pages/Admin/Innovation/UploadStartups";
    import HistoryChat from "@/pages/Admin/Innovation/HistoryChat";

    // DOCUMENTATION
    import DocumentationHome from "@/pages/Documentation/DocumentationHome";

    // IVEADMIN
    import SuperAdmin from "@/pages/SuperAdmin/SuperAdmin";

    import StartupUser from "@/pages/Admin/Innovation/StartupUser";
    import StartupRegistration from "@/pages/Admin/Innovation/StartupRegistration";
    import StartupManagement from "@/pages/Admin/Innovation/StartupManagement/StartupManagement";
    import StartupSearch from "@/pages/Admin/Innovation/StartupManagement/StartupSearch";
    import Synonyms from "@/pages/Admin/Innovation/Synonyms/Synonyms";
    import SynonymsParent from "@/pages/Admin/Innovation/Synonyms/SynonymsParent";
    import ApprovedStartupList from "@/pages/Admin/Innovation/StartupManagement/ApprovedStartupList";
    import ToBeConfirmedStartupList from "@/pages/Admin/Innovation/StartupManagement/ToBeConfirmedStartupList";
    import StartupInfo from "@/pages/Admin/Innovation/StartupManagement/StartupInfo";
    import StartupManagementParent from "@/pages/Admin/Innovation/StartupManagement/StartupManagementParent";
    import StartupSearchParent from "@/pages/Admin/Innovation/StartupManagement/StartupSearchParent";
    import ChallengeManagement from "@/pages/Admin/Innovation/ChallengeManagement/ChallengeManagement";
    import ChallengeDetails from "@/pages/Admin/Innovation/ChallengeManagement/ChallengeDetails";
    import PublicChallenges from "@/pages/Admin/Innovation/PublicPages/PublicChallenges";
    import PublicChallengeDetails from "@/pages/Admin/Innovation/PublicPages/PublicChallengeDetails";
    import ChallengeRegistration from "@/pages/Admin/Innovation/PublicPages/ChallengeRegistration";
    import StartupRequestModification from "../pages/Admin/Innovation/PublicPages/StartupRequestModification";
    import UserManagement from "@/pages/SuperAdmin/UserManagement";
    import GroupManagement from "@/pages/SuperAdmin/GroupManagement";
    import ApproverParent from "@/pages/Admin/Innovation/Approver/ApproverParent";
    import ApproverManagement from "@/pages/Admin/Innovation/Approver/ApproverManagement";
    import StartupModificationForm from "@/pages/Admin/Innovation/PublicPages/StartupModificationForm";
    import GhostPage from "@/pages/Admin/GhostPage/GhostPage";
    import LoginGhost from "@/pages/Admin/GhostPage/LoginGhost";
    import GhostChallengeDetails from "@/pages/Admin/GhostPage/GhostChallengeDetails";
    import GhostContactsTable from "@/pages/Admin/Innovation/Approver/GhostContactsTable";
    import TeCPage from "@/components/TeC/TeCPage";
    import Help from "@/pages/Admin/Help/Help";
    import PrivPolicyPage from "@/components/PrivPol/PrivPolicyPage";
    import RadarTrendList from "../pages/Radar/RadarTrendList";
    import OperationsHistory from "@/pages/Admin/Innovation/OperationsHistory";
    import OperationsHistoryParent from "@/pages/Admin/Innovation/OperationsHistoryParent";
    import PublicNews from "@/pages/Admin/Innovation/PublicPages/PublicNews.vue";
    import PublicNewsDetails from "@/pages/Admin/Innovation/PublicPages/PublicNewsDetails.vue";
    import NewsManagement from "@/pages/Admin/Innovation/NewsManagement/NewsManagement.vue";
    import NewsDetails from "@/pages/Admin/Innovation/NewsManagement/NewsDetails.vue";
    import UploadingStart from "@/pages/Admin/Innovation/UploadingStart.vue"
    import FeedbackPage from "../pages/Admin/Innovation/FeedbackPage/FeedbackPage";
    import ReviewPage from "../pages/Admin/Innovation/FeedbackPage/ReviewPage.vue";

    const routes = [
        {
            path: "/",
            component: AppStructure,
            meta: {
                auth: {
                    requiresAuth: false
                },
                showAppToolbar: true,
                showNavigationDrawer: true,
                showAppFooter: false,
                showContentToolbar: false,
                showContentHeader: false,
                showContentFooter: true
            },
            redirect: "homepage",
            children: [
                /*{
                    path: "radar",
                    name: "radar",
                    component: Radar,
                    props: true,
                    meta: {
                        id: "radar",
                        auth: {
                            requiresAuth: true,
                            acceptedRoles: [
                                IVEConfig.roles.ADMIN.name,
                                IVEConfig.roles.ADMIN_INNOVATION.name,
                                IVEConfig.roles.APPROVER_INNOVATION.name,
                                IVEConfig.roles.USER_INNOVATION.name,
                                IVEConfig.roles.RADAR_INNOVATION.name,

                            ]
                        },
                        showAppToolbar: true,
                        showAppToolbarInnovation: false,
                        colorToolbar: "gradient",
                        showNavigationDrawer: true,
                        showAppFooter: false,
                        showContentToolbar: false,
                        showContentHeader: false,
                        showContentFooter: true
                    }
                },*/
                /*{
                    path: "radar/list",
                    name: "radar-trend-list",
                    component: RadarTrendList,
                    props: true,
                    meta: {
                        id: "radar-trend-list",
                        auth: {
                            requiresAuth: true,
                            acceptedRoles: [
                                IVEConfig.roles.APPROVER_INNOVATION.name,


                            ]
                        },
                        showAppToolbar: true,
                        showAppToolbarInnovation: false,
                        colorToolbar: "gradient",
                        showNavigationDrawer: true,
                        showAppFooter: false,
                        showContentToolbar: false,
                        showContentHeader: false,
                        showContentFooter: true
                    }
                },*/
                {
                    path: "homepage",
                    name: "HomePage",
                    component: HomePage,
                    props: true,
                    meta: {
                        id: "homepage",
                        auth: {
                            requiresAuth: false
                        },
                        showAppToolbar: false,
                        showAppToolbarInnovation: true,
                        colorToolbar: "gradient",
                        showNavigationDrawer: false,
                        showAppFooter: false,
                        showContentToolbar: false,
                        showContentHeader: false,
                        showContentFooter: true
                    }
                },
                {
                    path: "help-startup",
                    name: "Help-startup",
                    component: Help,
                    props: true,
                    meta: {
                        id: "help-startup",
                        auth: {
                            requiresAuth: false
                        },
                        showAppToolbar: false,
                        showAppToolbarInnovation: true,
                        colorToolbar: "black",
                        showNavigationDrawer: false,
                        showAppFooter: false,
                        showContentToolbar: false,
                        showContentHeader: false,
                        showContentFooter: true
                    }
                },
                {
                    path: "help",
                    name: "help",
                    component: Help,
                    meta: {
                        id: "help",
                        auth: {
                            requiresAuth: true,
                            acceptedRoles: [
                                IVEConfig.roles.ADMIN.name,
                                IVEConfig.roles.ADMIN_INNOVATION.name,
                                IVEConfig.roles.APPROVER_INNOVATION.name,
                                IVEConfig.roles.USER_INNOVATION.name,
                                IVEConfig.roles.CUSTOMER_CHAT_INNOVATION.name,
                                IVEConfig.roles.CUSTOMER_INNOVATION.name,
                                IVEConfig.roles.RADAR_INNOVATION.name,

                            ]
                        },
                        toolbarTitle: "Help",
                        showAppToolbar: true,
                        showNavigationDrawer: true,
                        showAppFooter: false,
                        showContentToolbar: false,
                        showContentHeader: false,
                        showContentFooter: true
                    }
                },
                {
                    path: "terms-conditions",
                    name: "TeCPage",
                    component: TeCPage,
                    meta: {
                        id: "termsconditions",
                        auth: {
                            requiresAuth: false
                        },
                        showAppToolbar: false,
                        showAppToolbarInnovation: true,
                        colorToolbar: "black",
                        showNavigationDrawer: false,
                        showAppFooter: false,
                        showContentToolbar: false,
                        showContentHeader: false,
                        showContentFooter: true
                    }
                },
                {
                    path: "privacy-policy",
                    name: "PrivPolicyPage",
                    component: PrivPolicyPage,
                    meta: {
                        id: "privacypolicy",
                        auth: {
                            requiresAuth: false
                        },
                        showAppToolbar: false,
                        showAppToolbarInnovation: true,
                        colorToolbar: "black",
                        showNavigationDrawer: false,
                        showAppFooter: false,
                        showContentToolbar: false,
                        showContentHeader: false,
                        showContentFooter: true
                    },
                    /*
                    props: route => ({ query: route.query.q }),
                    key: (route) => {
                        // restituisce una stringa univoca per ogni rotta basata sulla
                        // combinazione del percorso e dei parametri di query
                        return `${route.path}-${JSON.stringify(route.query)}`;
                    },*/
                },
                {
                    path: "settings",
                    name: "Settings",
                    component: Settings,
                    meta: {
                        id: "settings",
                        auth: {
                            requiresAuth: true,
                            acceptedRoles: [
                                IVEConfig.roles.ADMIN.name,
                                IVEConfig.roles.USER.name,
                                IVEConfig.roles.USER_CHAT.name,
                                IVEConfig.roles.ADMIN_INNOVATION.name,
                                IVEConfig.roles.APPROVER_INNOVATION.name,
                                IVEConfig.roles.USER_INNOVATION.name,
                                IVEConfig.roles.CUSTOMER_CHAT_INNOVATION.name,
                                IVEConfig.roles.RADAR_INNOVATION.name,

                            ]
                        },
                        showAppToolbar: false,
                        showAppToolbarInnovation: false,
                        showNavigationDrawer: false,
                        showAppFooter: false,
                        showContentToolbar: false,
                        showContentHeader: false,
                        showContentFooter: true
                    }
                },
                /*{
                    path: "account",
                    name: "AccountManagement",
                    component: AccountManagement,
                    meta: {
                        id: "account",
                        auth: {
                            requiresAuth: true,
                            acceptedRoles: [
                                IVEConfig.roles.ADMIN.name,
                                IVEConfig.roles.USER.name,
                                IVEConfig.roles.USER_CHAT.name,
                                IVEConfig.roles.ADMIN_INNOVATION.name,
                                IVEConfig.roles.APPROVER_INNOVATION.name,
                                IVEConfig.roles.USER_INNOVATION.name,
                                IVEConfig.roles.RADAR_INNOVATION.name,

                            ]
                        },
                        showAppToolbar: false,
                        showAppToolbarInnovation: false,
                        showNavigationDrawer: false,
                        showAppFooter: false,
                        showContentToolbar: false,
                        showContentHeader: false,
                        showContentFooter: true
                    }
                },

                 */
                {
                    path: "documentation/home",
                    name: "Documentation",
                    component: DocumentationHome,
                    meta: {
                        id: "documentation",
                        auth: {
                            requiresAuth: true,
                            acceptedRoles: [
                                IVEConfig.roles.ADMIN.name,
                                IVEConfig.roles.USER.name,
                                IVEConfig.roles.USER_CHAT.name]
                        },
                        toolbarTitle: "Documentation",
                        loadUserActions: "LAB",
                        showNavigationDrawer: false,
                        showAppToolbar: true,
                        showAppToolbarInnovation: false,
                        showAppFooter: false,
                        showContentToolbar: false,
                        showContentHeader: false,
                        showContentFooter: true,
                    },
                },
                {
                    path: "oic11/results",
                    name: "LoginGhost",
                    component: LoginGhost,
                    props: true,
                    meta: {
                        id: "ghostpage-login",
                        auth: {
                            requiresAuth: false
                        },
                        showAppToolbar: false,
                        showAppToolbarInnovation: false,
                        colorToolbar: "gradient",
                        showNavigationDrawer: false,
                        showAppFooter: false,
                        showContentToolbar: false,
                        showContentHeader: false,
                        showContentFooter: false,
                        showAppToolbarGhost: true
                    },
                },
                {
                    path: "oic11/results/challenges",
                    name: "GhostPage",
                    component: GhostPage,
                    meta: {
                        id: "ghost-page",
                        auth: {
                            requiresAuth: true,
                            acceptedRoles: [
                                IVEConfig.roles.GHOST_INNOVATION.name,
                            ]
                        },
                        showAppToolbar: false,
                        showAppToolbarInnovation: false,
                        colorToolbar: "black",
                        showNavigationDrawer: false,
                        showAppFooter: false,
                        showContentToolbar: false,
                        showContentHeader: false,
                        showContentFooter: false,
                        showAppToolbarGhostLogout: true

                    },
                },
                {
                    path: "oic11/results/challenges/:_id",
                    name: "GhostChallengeDetails",
                    props: true,
                    component: GhostChallengeDetails,
                    meta: {
                        id: "discoverChallenges-details",
                        auth: {
                            requiresAuth: true,
                            acceptedRoles: [
                                IVEConfig.roles.GHOST_INNOVATION.name,
                            ]
                        },
                        showAppToolbar: false,
                        showAppToolbarInnovation: false,
                        colorToolbar: "black",
                        showNavigationDrawer: false,
                        showAppFooter: false,
                        showContentToolbar: false,
                        showContentHeader: false,
                        showContentFooter: false,
                        showAppToolbarGhostLogout: true

                    }
                },

                {
                    path: "iadmin",
                    name: "Iadmin",
                    redirect: "iadmin/newUser",
                    component: SuperAdmin,
                    meta: {
                        id: "iadmin",
                        auth: {
                            requiresAuth: true,
                            acceptedRoles: [
                                IVEConfig.roles.IVE_ADMIN.name,
                            ]
                        },
                        toolbarTitle: "IVE Admin",
                        loadNavigationDrawer: IVEConfig.roles.IVE_ADMIN.name,
                        loadUserActions: IVEConfig.roles.IVE_ADMIN.name,
                        showAppToolbar: true,
                        showNavigationDrawer: true,
                        showAppFooter: false,
                        showAppToolbarInnovation: false,
                        showContentToolbar: false,
                        showContentHeader: false,
                        showContentFooter: true
                    },
                    children: [
                        {
                            path: "userManagement",
                            name: "UserManagement",
                            component: UserManagement,
                            meta: {
                                id: "iadmin-userManagement",
                                auth: {
                                    requiresAuth: true,
                                    acceptedRoles: [
                                        //IVEConfig.roles.ADMIN_INNOVATION.name,
                                        IVEConfig.roles.APPROVER_INNOVATION.name,
                                        IVEConfig.roles.ADMIN.name,
                                    ]
                                },
                                toolbarTitle: "User Management",
                                //loadNavigationDrawer: IVEConfig.roles.ADMIN_INNOVATION.name,
                                //loadUserActions: IVEConfig.roles.ADMIN_INNOVATION.name,
                                showAppToolbar: true,
                                showAppToolbarInnovation: false,
                                showNavigationDrawer: true,
                                showAppFooter: false,
                                showContentToolbar: false,
                                showContentHeader: false,
                                showContentFooter: true
                            }
                        },
                        {
                            path: "groupManagement",
                            name: "GroupManagement",
                            component: GroupManagement,
                            meta: {
                                id: "iadmin-groupManagement",
                                auth: {
                                    requiresAuth: true,
                                    acceptedRoles: [
                                        IVEConfig.roles.ADMIN_INNOVATION.name,
                                        IVEConfig.roles.ADMIN.name,
                                        IVEConfig.roles.APPROVER_INNOVATION.name,
                                    ]
                                },
                                toolbarTitle: "Group Management",
                                loadNavigationDrawer: IVEConfig.roles.ADMIN_INNOVATION.name,
                                loadUserActions: IVEConfig.roles.ADMIN_INNOVATION.name,
                                showAppToolbar: true,
                                showAppToolbarInnovation: false,
                                showNavigationDrawer: true,
                                showAppFooter: false,
                                showContentToolbar: false,
                                showContentHeader: false,
                                showContentFooter: true
                            }
                        },
                        {
                            path: "challengeManagement",
                            name: "ChallengeManagement",
                            component: ChallengeManagement,
                            meta: {
                                id: "iadmin-challenge-management",
                                auth: {
                                    requiresAuth: true,
                                    acceptedRoles: [
                                        IVEConfig.roles.ADMIN_INNOVATION.name,
                                        IVEConfig.roles.CUSTOMER_INNOVATION.name,
                                        IVEConfig.roles.APPROVER_INNOVATION.name,
                                        IVEConfig.roles.CUSTOMER_CHAT_INNOVATION.name,
                                        IVEConfig.roles.ADMIN.name,
                                    ]
                                },
                                toolbarTitle: "Challenge Management",
                                loadNavigationDrawer: IVEConfig.roles.ADMIN_INNOVATION.name,
                                loadUserActions: IVEConfig.roles.CUSTOMER_INNOVATION.name,
                                showAppToolbar: true,
                                showAppToolbarInnovation: false,
                                showNavigationDrawer: true,
                                showAppFooter: false,
                                showContentToolbar: false,
                                showContentHeader: false,
                                showContentFooter: true
                            }
                        },
                        {
                            path: "challengeDetails/:_id",
                            name: "ChallengeDetails",
                            props: true,
                            component: ChallengeDetails,
                            meta: {
                                id: "iadmin-challenge-details",
                                auth: {
                                    requiresAuth: true,
                                    acceptedRoles: [
                                        IVEConfig.roles.ADMIN_INNOVATION.name,
                                        IVEConfig.roles.APPROVER_INNOVATION.name,
                                        IVEConfig.roles.CUSTOMER_INNOVATION.name,
                                        IVEConfig.roles.CUSTOMER_CHAT_INNOVATION.name,
                                        IVEConfig.roles.ADMIN.name,
                                    ]
                                },
                                toolbarTitle: "Challenge Details",
                                loadNavigationDrawer: IVEConfig.roles.ADMIN_INNOVATION.name,
                                loadUserActions: IVEConfig.roles.ADMIN_INNOVATION.name,
                                showAppToolbar: true,
                                showAppToolbarInnovation: false,
                                showNavigationDrawer: true,
                                showAppFooter: false,
                                showContentToolbar: false,
                                showContentHeader: false,
                                showContentFooter: true
                            }
                        },
                        {
                            path: "excel-upload",
                            name: "UploadingStart",
                            component: UploadingStart,
                            meta: {
                                id: "newupload",
                                auth: {
                                    requiresAuth: true,
                                    acceptedRoles: [
                                        IVEConfig.roles.APPROVER_INNOVATION.name,
                                        IVEConfig.roles.ADMIN_INNOVATION.name,
                                        IVEConfig.roles.ADMIN.name,
                                    ]
                                },
                                toolbarTitle: "Excel Uploading Start",
                                loadNavigationDrawer: IVEConfig.roles.APPROVER_INNOVATION.name,
                                loadUserActions: IVEConfig.roles.APPROVER_INNOVATION.name,
                                showAppToolbar: true,
                                showAppToolbarInnovation: false,
                                showNavigationDrawer: true,
                                showAppFooter: false,
                                showContentToolbar: false,
                                showContentHeader: false,
                                showContentFooter: true
                            }
                        },
                        /*{
                            path: "feedback-page",
                            name: "SearchList",
                            component: FeedbackPage,
                            meta: {
                                id: "feedback",
                                auth: {
                                    requiresAuth: true,
                                    acceptedRoles: [
                                        IVEConfig.roles.USER.name,
                                        IVEConfig.roles.USER_CHAT.name,
                                        IVEConfig.roles.USER_INNOVATION.name,
                                        IVEConfig.roles.CUSTOMER_CHAT_INNOVATION.name,
                                        //IVEConfig.roles.APPROVER_INNOVATION.name,
                                        //IVEConfig.roles.ADMIN_INNOVATION.name,
                                        //IVEConfig.roles.ADMIN.name,
                                    ]
                                },
                                toolbarTitle: "Feedback Page",
                                loadNavigationDrawer: IVEConfig.roles.APPROVER_INNOVATION.name,
                                loadUserActions: IVEConfig.roles.APPROVER_INNOVATION.name,
                                showAppToolbar: true,
                                showAppToolbarInnovation: false,
                                showNavigationDrawer: true,
                                showAppFooter: false,
                                showContentToolbar: false,
                                showContentHeader: false,
                                showContentFooter: true
                            }
                        },
                        {
                            path: "feedback-page",
                            name: "SearchList",
                            component: FeedbackPage,
                            meta: {
                                id: "feedback",
                                auth: {
                                    requiresAuth: true,
                                    acceptedRoles: [
                                        IVEConfig.roles.APPROVER_INNOVATION.name,
                                        IVEConfig.roles.ADMIN_INNOVATION.name,
                                        IVEConfig.roles.ADMIN.name,
                                    ]
                                },
                                toolbarTitle: "Feedback Page",
                                loadNavigationDrawer: IVEConfig.roles.APPROVER_INNOVATION.name,
                                loadUserActions: IVEConfig.roles.APPROVER_INNOVATION.name,
                                showAppToolbar: true,
                                showAppToolbarInnovation: false,
                                showNavigationDrawer: true,
                                showAppFooter: false,
                                showContentToolbar: false,
                                showContentHeader: false,
                                showContentFooter: true
                            }
                        },
                        {
                            path: "review-page",
                            name: "SearchList",
                            component: ReviewPage,
                            meta: {
                                id: "review",
                                auth: {
                                    requiresAuth: true,
                                    acceptedRoles: [
                                        IVEConfig.roles.APPROVER_INNOVATION.name,
                                        IVEConfig.roles.ADMIN_INNOVATION.name,
                                        IVEConfig.roles.ADMIN.name,
                                    ]
                                },
                                toolbarTitle: "Review Page",
                                loadNavigationDrawer: IVEConfig.roles.APPROVER_INNOVATION.name,
                                loadUserActions: IVEConfig.roles.APPROVER_INNOVATION.name,
                                showAppToolbar: true,
                                showAppToolbarInnovation: false,
                                showNavigationDrawer: true,
                                showAppFooter: false,
                                showContentToolbar: false,
                                showContentHeader: false,
                                showContentFooter: true
                            }
                        },*/
                        {
                            path: "newsManagement",
                            name: "NewsManagement",
                            component: NewsManagement,
                            meta: {
                                id: "iadmin-news-management",
                                auth: {
                                    requiresAuth: true,
                                    acceptedRoles: [
                                        IVEConfig.roles.ADMIN_INNOVATION.name,
                                        IVEConfig.roles.CUSTOMER_INNOVATION.name,
                                        IVEConfig.roles.APPROVER_INNOVATION.name,
                                        IVEConfig.roles.CUSTOMER_CHAT_INNOVATION.name,
                                        IVEConfig.roles.ADMIN.name,
                                    ]
                                },
                                toolbarTitle: "News Management",
                                loadNavigationDrawer: IVEConfig.roles.ADMIN_INNOVATION.name,
                                loadUserActions: IVEConfig.roles.CUSTOMER_INNOVATION.name,
                                showAppToolbar: true,
                                showAppToolbarInnovation: false,
                                showNavigationDrawer: true,
                                showAppFooter: false,
                                showContentToolbar: false,
                                showContentHeader: false,
                                showContentFooter: true
                            }
                        },
                        {
                            path: "NewsDetails/:_id",
                            name: "NewsDetails",
                            props: true,
                            component: NewsDetails,
                            meta: {
                                id: "iadmin-news-details",
                                auth: {
                                    requiresAuth: true,
                                    acceptedRoles: [
                                        IVEConfig.roles.ADMIN_INNOVATION.name,
                                        IVEConfig.roles.APPROVER_INNOVATION.name,
                                        IVEConfig.roles.CUSTOMER_INNOVATION.name,
                                        IVEConfig.roles.CUSTOMER_CHAT_INNOVATION.name,
                                        IVEConfig.roles.ADMIN.name,
                                    ]
                                },
                                toolbarTitle: "News Details",
                                loadNavigationDrawer: IVEConfig.roles.ADMIN_INNOVATION.name,
                                loadUserActions: IVEConfig.roles.ADMIN_INNOVATION.name,
                                showAppToolbar: true,
                                showAppToolbarInnovation: false,
                                showNavigationDrawer: true,
                                showAppFooter: false,
                                showContentToolbar: false,
                                showContentHeader: false,
                                showContentFooter: true
                            }
                        },
                        {
                            path: "startupManagement",
                            name: "StartupManagementParent",
                            component: StartupManagementParent,
                            redirect: "",
                            meta: {
                                id: "startup-management-parent",
                                auth: {
                                    requiresAuth: true,
                                    acceptedRoles: [
                                        IVEConfig.roles.ADMIN.name,
                                        IVEConfig.roles.ADMIN_INNOVATION.name,
                                        IVEConfig.roles.APPROVER_INNOVATION.name,
                                    ]
                                },
                                toolbarTitle: "Plugins",
                                loadNavigationDrawer: IVEConfig.roles.ADMIN_INNOVATION.name,
                                loadUserActions: IVEConfig.roles.ADMIN_INNOVATION.name,
                                showAppToolbar: true,
                                showAppToolbarInnovation: false,
                                showNavigationDrawer: true,
                                showAppFooter: false,
                                showContentToolbar: false,
                                showContentHeader: false,
                                showContentFooter: true
                            },
                            children: [
                                {
                                    path: "",
                                    name: "StartupManagement",
                                    component: StartupManagement,
                                    meta: {
                                        id: "startup-management",
                                        auth: {
                                            requiresAuth: true,
                                            acceptedRoles: [
                                                IVEConfig.roles.APPROVER_INNOVATION.name,
                                                IVEConfig.roles.ADMIN_INNOVATION.name,
                                                IVEConfig.roles.ADMIN.name,
                                            ]
                                        },
                                        toolbarTitle: "Startup Management",
                                        loadNavigationDrawer: IVEConfig.roles.ADMIN_INNOVATION.name,
                                        loadUserActions: IVEConfig.roles.ADMIN_INNOVATION.name,
                                        showAppToolbar: true,
                                        showAppToolbarInnovation: false,
                                        showNavigationDrawer: true,
                                        showAppFooter: false,
                                        showContentToolbar: false,
                                        showContentHeader: false,
                                        showContentFooter: true
                                    }
                                },
                                {
                                    path: "list",
                                    name: "ApprovedStartupList",
                                    component: ApprovedStartupList,
                                    meta: {
                                        id: "startup-list",
                                        auth: {
                                            requiresAuth: true,
                                            acceptedRoles: [
                                                IVEConfig.roles.ADMIN.name,
                                                IVEConfig.roles.ADMIN_INNOVATION.name,
                                                IVEConfig.roles.APPROVER_INNOVATION.name,
                                            ]
                                        },
                                        toolbarTitle: "Startup List",
                                        loadUserActions: IVEConfig.roles.ADMIN_INNOVATION.name,
                                        showNavigationDrawer: false,
                                        showAppToolbar: true,
                                        showAppToolbarInnovation: false,
                                        showAppFooter: false,
                                        showContentToolbar: false,
                                        showContentHeader: false,
                                        showContentFooter: true
                                    }
                                },
                                {
                                    path: "toBeConfirmedList",
                                    name: "ToBeConfirmedStartupList",
                                    component: ToBeConfirmedStartupList,
                                    meta: {
                                        id: "tobeconfirmedstartup-list",
                                        auth: {
                                            requiresAuth: true,
                                            acceptedRoles: [
                                                IVEConfig.roles.APPROVER_INNOVATION.name,
                                                IVEConfig.roles.ADMIN.name,
                                                IVEConfig.roles.ADMIN_INNOVATION.name,
                                            ]
                                        },
                                        toolbarTitle: "To be confirmed Startup List",
                                        loadUserActions: IVEConfig.roles.ADMIN_INNOVATION.name,
                                        showNavigationDrawer: false,
                                        showAppToolbar: true,
                                        showAppToolbarInnovation: false,
                                        showAppFooter: false,
                                        showContentToolbar: false,
                                        showContentHeader: false,
                                        showContentFooter: true
                                    }
                                },
                                {
                                    path: ":startupId",
                                    name: "StartupInfo",
                                    props: true,
                                    component: StartupInfo,
                                    meta: {
                                        id: "startup-info",
                                        auth: {
                                            requiresAuth: true,
                                            acceptedRoles: [
                                                IVEConfig.roles.ADMIN.name,
                                                IVEConfig.roles.APPROVER_INNOVATION.name,
                                                IVEConfig.roles.ADMIN_INNOVATION.name,
                                            ]
                                        },
                                        toolbarTitle: "Startup",
                                        loadNavigationDrawer: IVEConfig.roles.ADMIN_INNOVATION.name,
                                        loadUserActions: IVEConfig.roles.ADMIN_INNOVATION.name,
                                        showAppToolbar: true,
                                        showAppToolbarInnovation: false,
                                        showNavigationDrawer: true,
                                        showAppFooter: false,
                                        showContentToolbar: false,
                                        showContentHeader: false,
                                        showContentFooter: true
                                    }
                                }

                            ]
                        },
                        {
                            path: "startupSearch",
                            name: "StartupSearchParent",
                            component: StartupSearchParent,
                            redirect: "",
                            meta: {
                                id: "startup-search-parent",
                                auth: {
                                    requiresAuth: true,
                                    acceptedRoles: [
                                        IVEConfig.roles.ADMIN.name,
                                        IVEConfig.roles.APPROVER_INNOVATION.name,
                                        IVEConfig.roles.ADMIN_INNOVATION.name,
                                    ]
                                },
                                toolbarTitle: "Startup Advanced Search",
                                loadNavigationDrawer: IVEConfig.roles.ADMIN_INNOVATION.name,
                                loadUserActions: IVEConfig.roles.ADMIN_INNOVATION.name,
                                showAppToolbar: true,
                                showAppToolbarInnovation: false,
                                showNavigationDrawer: true,
                                showAppFooter: false,
                                showContentToolbar: false,
                                showContentHeader: false,
                                showContentFooter: true
                            },
                            children: [
                                {
                                    path: "",
                                    name: "StartupSearch",
                                    component: StartupSearch,
                                    meta: {
                                        id: "startup-search",
                                        auth: {
                                            requiresAuth: true,
                                            acceptedRoles: [
                                                IVEConfig.roles.APPROVER_INNOVATION.name,
                                                IVEConfig.roles.ADMIN_INNOVATION.name,
                                                IVEConfig.roles.ADMIN.name,
                                            ]
                                        },
                                        toolbarTitle: "Startup Search",
                                        loadNavigationDrawer: IVEConfig.roles.ADMIN_INNOVATION.name,
                                        loadUserActions: IVEConfig.roles.ADMIN_INNOVATION.name,
                                        showAppToolbar: true,
                                        showAppToolbarInnovation: false,
                                        showNavigationDrawer: true,
                                        showAppFooter: false,
                                        showContentToolbar: false,
                                        showContentHeader: false,
                                        showContentFooter: true
                                    }
                                },
                            ]
                        },
                        {
                            path: "synonyms",
                            name: "SynonymsParent",
                            component: SynonymsParent,
                            redirect: "",
                            meta: {
                                id: "synonyms-parent",
                                auth: {
                                    requiresAuth: true,
                                    acceptedRoles: [
                                        IVEConfig.roles.APPROVER_INNOVATION.name,
                                        IVEConfig.roles.ADMIN.name,
                                        IVEConfig.roles.ADMIN_INNOVATION.name,
                                    ]
                                },
                                toolbarTitle: "Startup Advanced Search",
                                loadNavigationDrawer: IVEConfig.roles.ADMIN_INNOVATION.name,
                                loadUserActions: IVEConfig.roles.ADMIN_INNOVATION.name,
                                showAppToolbar: true,
                                showAppToolbarInnovation: false,
                                showNavigationDrawer: true,
                                showAppFooter: false,
                                showContentToolbar: false,
                                showContentHeader: false,
                                showContentFooter: true
                            },
                            children: [
                                {
                                    path: "",
                                    name: "Synonyms",
                                    component: Synonyms,
                                    meta: {
                                        id: "synonyms",
                                        auth: {
                                            requiresAuth: true,
                                            acceptedRoles: [
                                                IVEConfig.roles.APPROVER_INNOVATION.name,
                                                IVEConfig.roles.ADMIN_INNOVATION.name,
                                                IVEConfig.roles.ADMIN.name,
                                            ]
                                        },
                                        toolbarTitle: "Synonyms",
                                        loadNavigationDrawer: IVEConfig.roles.ADMIN_INNOVATION.name,
                                        loadUserActions: IVEConfig.roles.ADMIN_INNOVATION.name,
                                        showAppToolbar: true,
                                        showAppToolbarInnovation: false,
                                        showNavigationDrawer: true,
                                        showAppFooter: false,
                                        showContentToolbar: false,
                                        showContentHeader: false,
                                        showContentFooter: true
                                    }
                                },
                            ]
                        }
                    ],
                },
                {
                    path: "discoverNews",
                    name: "PublicNews",
                    component: PublicNews,
                    props: true,
                    meta: {
                        id: "discoverNews",
                        auth: {
                            requiresAuth: false
                        },
                        showAppToolbar: false,
                        showAppToolbarInnovation: true,
                        colorToolbar: "black",
                        showNavigationDrawer: false,
                        showAppFooter: false,
                        showContentToolbar: false,
                        showContentHeader: false,
                        showContentFooter: true
                    }
                },
                {
                    path: "discoverNews/:_id",
                    name: "PublicNewsDetails",
                    props: true,
                    component: PublicNewsDetails,
                    meta: {
                        id: "discoverNews-details",
                        auth: {
                            requiresAuth: false,
                        },
                        showAppToolbar: false,
                        showAppToolbarInnovation: true,
                        colorToolbar: "gradient",
                        showNavigationDrawer: false,
                        showAppFooter: false,
                        showContentToolbar: false,
                        showContentHeader: false,
                        showContentFooter: true
                    }
                },
                {
                    path: "discoverChallenges",
                    name: "PublicChallenges",
                    component: PublicChallenges,
                    props: true,
                    meta: {
                        id: "discoverChallenges",
                        auth: {
                            requiresAuth: false
                        },
                        showAppToolbar: false,
                        showAppToolbarInnovation: true,
                        colorToolbar: "black",
                        showNavigationDrawer: false,
                        showAppFooter: false,
                        showContentToolbar: false,
                        showContentHeader: false,
                        showContentFooter: true
                    }
                },
                {
                    path: "discoverChallenges/:_id",
                    name: "PublicChallengeDetails",
                    props: true,
                    component: PublicChallengeDetails,
                    meta: {
                        id: "discoverChallenges-details",
                        auth: {
                            requiresAuth: false,
                        },
                        showAppToolbar: false,
                        showAppToolbarInnovation: true,
                        colorToolbar: "gradient",
                        showNavigationDrawer: false,
                        showAppFooter: false,
                        showContentToolbar: false,
                        showContentHeader: false,
                        showContentFooter: true
                    }
                },
                {
                    path: "discoverChallenges/:_id/registration",
                    name: "ChallengeRegistration",
                    props: true,
                    component: ChallengeRegistration,
                    meta: {
                        id: "discoverChallenges-registration",
                        auth: {
                            requiresAuth: false,
                        },
                        showAppToolbar: false,
                        showAppToolbarInnovation: true,
                        colorToolbar: "black",
                        showNavigationDrawer: false,
                        showAppFooter: false,
                        showContentToolbar: false,
                        showContentHeader: false,
                        showContentFooter: true
                    }
                },
                {
                    path: "startup",
                    name: "Startup",
                    redirect: "startup/registration",
                    component: StartupUser,
                    meta: {
                        id: "startup",
                        auth: {
                            requiresAuth: false,
                        },
                        showAppToolbar: false,
                        showAppToolbarInnovation: true,
                        colorToolbar: "black",
                        showNavigationDrawer: false,
                        showAppFooter: false,
                        showContentToolbar: false,
                        showContentHeader: false,
                        showContentFooter: true
                    },
                    children: [
                        {
                            path: "registration",
                            name: "StartupRegistration",
                            component: StartupRegistration,
                            meta: {
                                id: "startup-registration",
                                auth: {
                                    requiresAuth: false,
                                },
                                toolbarTitle: "Startup Registration",
                                colorToolbar: "black",
                                showAppToolbar: false,
                                showAppToolbarInnovation: true,
                                showNavigationDrawer: false,
                                showAppFooter: false,
                                showContentToolbar: false,
                                showContentHeader: false,
                                showContentFooter: true
                            }
                        },
                        {
                            path: "modification",
                            name: "StartupRequestModification",
                            component: StartupRequestModification,
                            meta: {
                                id: "startup-modification",
                                auth: {
                                    requiresAuth: false,
                                },
                                toolbarTitle: "Startup Modification",
                                colorToolbar: "black",
                                showAppToolbar: false,
                                showAppToolbarInnovation: true,
                                showNavigationDrawer: false,
                                showAppFooter: false,
                                showContentToolbar: false,
                                showContentHeader: false,
                                showContentFooter: true
                            }
                        },
                        {
                            path: "edit",
                            name: "StartupModificationForm",
                            component: StartupModificationForm,
                            meta: {
                                id: "startup-modification-form",
                                auth: {
                                    requiresAuth: false,
                                },
                                toolbarTitle: "Edit Startup Information",
                                colorToolbar: "black",
                                showAppToolbar: false,
                                showAppToolbarInnovation: true,
                                showNavigationDrawer: false,
                                showAppFooter: false,
                                showContentToolbar: false,
                                showContentHeader: false,
                                showContentFooter: true
                            }
                        },
                    ],
                },
                {
                    path: "user",
                    name: "User",
                    redirect: "user/dialogs",
                    component: User,
                    meta: {
                        id: "user",
                        auth: {
                            requiresAuth: true,
                            acceptedRoles: [
                                IVEConfig.roles.USER.name,
                            ]
                        },
                        toolbarTitle: "User",
                        loadNavigationDrawer: IVEConfig.roles.USER.name,
                        loadUserActions: IVEConfig.roles.USER.name,
                        showAppToolbar: true,
                        showAppToolbarInnovation: false,
                        showNavigationDrawer: true,
                        showAppFooter: false,
                        showContentToolbar: false,
                        showContentHeader: false,
                        showContentFooter: true
                    },
                    children: [
                        {
                            path: "dialogs",
                            name: "DialogsUser",
                            component: DialogsTesting,
                            meta: {
                                id: "user-dialogs",
                                auth: {
                                    requiresAuth: true,
                                    acceptedRoles: [
                                        IVEConfig.roles.USER.name,
                                        IVEConfig.roles.USER_CHAT.name,
                                        IVEConfig.roles.USER_INNOVATION.name,
                                        IVEConfig.roles.CUSTOMER_CHAT_INNOVATION.name,
                                        IVEConfig.roles.APPROVER_INNOVATION.name,
                                        IVEConfig.roles.ADMIN_INNOVATION.name,
                                    ]
                                },
                                toolbarTitle: "Talk with me",
                                loadNavigationDrawer: IVEConfig.roles.USER.name,
                                loadUserActions: IVEConfig.roles.USER.name,
                                showAppToolbar: true,
                                showAppToolbarInnovation: false,
                                showNavigationDrawer: true,
                                showAppFooter: false,
                                showContentToolbar: false,
                                showContentHeader: false,
                                showContentFooter: false
                            }
                        },
                    ],
                },

                {
                    path: "admin",
                    name: "Admin",
                    redirect: "admin/training",
                    component: Admin,
                    meta: {
                        id: "admin",
                        auth: {
                            requiresAuth: true,
                            acceptedRoles: [
                                IVEConfig.roles.ADMIN.name
                            ]
                        },
                        toolbarTitle: "Admin",
                        loadNavigationDrawer: IVEConfig.roles.ADMIN.name,
                        loadUserActions: IVEConfig.roles.ADMIN.name,
                        showAppToolbar: true,
                        showAppToolbarInnovation: false,
                        showNavigationDrawer: true,
                        showAppFooter: false,
                        showContentToolbar: false,
                        showContentHeader: false,
                        showContentFooter: true
                    },
                    children: [
                        {
                            path: "conversation",
                            name: "Conversation",
                            component: ServicesCategoriesDetails,
                            meta: {
                                id: "admin-conversation",
                                auth: {
                                    requiresAuth: true,
                                    acceptedRoles: [
                                        IVEConfig.roles.ADMIN.name
                                    ]
                                },
                                toolbarTitle: "Conversation",
                                loadNavigationDrawer: IVEConfig.roles.ADMIN.name,
                                loadUserActions: IVEConfig.roles.ADMIN.name,
                                showAppToolbar: true,
                                showAppToolbarInnovation: false,
                                showNavigationDrawer: true,
                                showAppFooter: false,
                                showContentToolbar: false,
                                showContentHeader: false,
                                showContentFooter: true
                            }
                        },
                        {
                            path: "training",
                            name: "Training",
                            redirect: "training/dialogs",
                            component: Training,
                            meta: {
                                id: "admin-training",
                                auth: {
                                    requiresAuth: true,
                                    acceptedRoles: [
                                        IVEConfig.roles.ADMIN.name
                                    ]
                                },
                                toolbarTitle: "Training",
                                loadNavigationDrawer: IVEConfig.roles.ADMIN.name,
                                loadUserActions: IVEConfig.roles.ADMIN.name,
                                showAppToolbar: true,
                                showAppToolbarInnovation: false,
                                showNavigationDrawer: true,
                                showAppFooter: false,
                                showContentToolbar: false,
                                showContentHeader: false,
                                showContentFooter: true
                            },
                            children: [
                                {
                                    path: "dialogs",
                                    name: "DialogsTraining",
                                    component: DialogsTraining,
                                    redirect: "dialogs/intents",
                                    meta: {
                                        id: "admin-training-conversation",
                                        auth: {
                                            requiresAuth: true,
                                            acceptedRoles: [
                                                IVEConfig.roles.ADMIN.name
                                            ]
                                        },
                                        toolbarTitle: "Dialogs",
                                        loadNavigationDrawer: IVEConfig.roles.ADMIN.name,
                                        loadUserActions: IVEConfig.roles.ADMIN.name,
                                        showAppToolbar: true,
                                        showAppToolbarInnovation: false,
                                        showNavigationDrawer: true,
                                        showAppFooter: false,
                                        showContentToolbar: false,
                                        showContentHeader: false,
                                        showContentFooter: true
                                    },
                                    children: [
                                        {
                                            path: "history-chat-startups",
                                            name: "HistoryChat",
                                            component: HistoryChat,
                                            meta: {
                                                id: "admin-training-historyChatStartups",
                                                auth: {
                                                    requiresAuth: true,
                                                    acceptedRoles: [
                                                        IVEConfig.roles.ADMIN_INNOVATION.name,
                                                        IVEConfig.roles.APPROVER_INNOVATION.name,
                                                        IVEConfig.roles.ADMIN.name
                                                    ]
                                                },
                                                toolbarTitle: "History chat",
                                                loadNavigationDrawer: IVEConfig.roles.ADMIN_INNOVATION.name,
                                                loadUserActions: IVEConfig.roles.ADMIN_INNOVATION.name,
                                                showAppToolbar: true,
                                                showAppToolbarInnovation: false,
                                                showNavigationDrawer: true,
                                                showAppFooter: false,
                                                showContentToolbar: false,
                                                showContentHeader: false,
                                                showContentFooter: true
                                            }

                                        },
                                        {
                                            path: "upload-startups",
                                            name: "UploadStartups",
                                            component: UploadStartups,
                                            meta: {
                                                id: "admin-training-uploadStartups",
                                                auth: {
                                                    requiresAuth: true,
                                                    acceptedRoles: [
                                                        IVEConfig.roles.APPROVER_INNOVATION.name,
                                                        IVEConfig.roles.ADMIN.name
                                                    ]
                                                },
                                                toolbarTitle: "Upload Startups file",
                                                loadNavigationDrawer: IVEConfig.roles.APPROVER_INNOVATION.name,
                                                loadUserActions: IVEConfig.roles.APPROVER_INNOVATION.name,
                                                showAppToolbar: true,
                                                showAppToolbarInnovation: false,
                                                showNavigationDrawer: true,
                                                showAppFooter: false,
                                                showContentToolbar: false,
                                                showContentHeader: false,
                                                showContentFooter: true
                                            }

                                        },
                                        {
                                            // INTENT LIST
                                            path: "intents",
                                            name: "IntentsListTraining",
                                            component: IntentsListTraining,
                                            meta: {
                                                id: "admin-training-intents-list",
                                                auth: {
                                                    requiresAuth: true,
                                                    acceptedRoles: [
                                                        IVEConfig.roles.ADMIN.name
                                                    ]
                                                },
                                                toolbarTitle: "Intents List",
                                                loadNavigationDrawer: IVEConfig.roles.ADMIN.name,
                                                loadUserActions: IVEConfig.roles.ADMIN.name,
                                                showAppToolbar: true,
                                                showAppToolbarInnovation: false,
                                                showNavigationDrawer: true,
                                                showAppFooter: false,
                                                showContentToolbar: false,
                                                showContentHeader: true,
                                                showContentFooter: true,
                                                headerData: {
                                                    img: require("@/assets/img/services/chatbotTest.png"),
                                                    description: "homePage.conversation.children.intentList.detailedDescription",
                                                    title: "homePage.conversation.children.intentList.header"
                                                }
                                            }
                                        },
                                        {
                                            path: "intents/:id",
                                            name: "IntentTraining",
                                            props: true,
                                            component: IntentDetailsTraining,
                                            meta: {
                                                id: "admin-training-intents-details",
                                                auth: {
                                                    requiresAuth: true,
                                                    acceptedRoles: [
                                                        IVEConfig.roles.ADMIN.name
                                                    ]
                                                },
                                                toolbarTitle: "Intents",
                                                loadNavigationDrawer: IVEConfig.roles.ADMIN.name,
                                                loadUserActions: IVEConfig.roles.ADMIN.name,
                                                showAppToolbar: true,
                                                showAppToolbarInnovation: false,
                                                showNavigationDrawer: true,
                                                showAppFooter: false,
                                                showContentToolbar: false,
                                                showContentHeader: false,
                                                showContentFooter: true
                                            }
                                        }
                                    ]
                                },
                                {
                                    path: "plugins",
                                    name: "PluginsTraining",
                                    component: PluginsTraining,
                                    redirect: "",
                                    meta: {
                                        id: "admin-training-plugins",
                                        auth: {
                                            requiresAuth: true,
                                            acceptedRoles: [
                                                IVEConfig.roles.ADMIN.name
                                            ]
                                        },
                                        toolbarTitle: "Plugins",
                                        loadNavigationDrawer: IVEConfig.roles.ADMIN.name,
                                        loadUserActions: IVEConfig.roles.ADMIN.name,
                                        showAppToolbar: true,
                                        showAppToolbarInnovation: false,
                                        showNavigationDrawer: true,
                                        showAppFooter: false,
                                        showContentToolbar: false,
                                        showContentHeader: false,
                                        showContentFooter: true
                                    },
                                    children: [
                                        {
                                            path: "",
                                            name: "PluginsListTraining",
                                            component: PluginsListTraining,
                                            meta: {
                                                id: "admin-training-plugins-list",
                                                auth: {
                                                    requiresAuth: true,
                                                    acceptedRoles: [
                                                        IVEConfig.roles.ADMIN.name
                                                    ]
                                                },
                                                toolbarTitle: "Create Plugin",
                                                loadNavigationDrawer: IVEConfig.roles.ADMIN.name,
                                                loadUserActions: IVEConfig.roles.ADMIN.name,
                                                showAppToolbar: true,
                                                showAppToolbarInnovation: false,
                                                showNavigationDrawer: true,
                                                showAppFooter: false,
                                                showContentToolbar: false,
                                                showContentHeader: true,
                                                showContentFooter: true,
                                                headerData: {
                                                    img: require("@/assets/img/services/plugIn.png"),
                                                    description: "homePage.conversation.children.plugin.detailedDescription",
                                                    title: "homePage.conversation.children.plugin.header"
                                                }
                                            },
                                        },
                                        {
                                            path: ":pluginType/:pluginId",
                                            name: "PluginDetailsTraining",
                                            props: true,
                                            component: PluginDetailsTraining,
                                            meta: {
                                                id: "admin-training-plugin-details",
                                                auth: {
                                                    requiresAuth: true,
                                                    acceptedRoles: [
                                                        IVEConfig.roles.ADMIN.name
                                                    ]
                                                },
                                                toolbarTitle: "Update Plugin",
                                                loadNavigationDrawer: IVEConfig.roles.ADMIN.name,
                                                loadUserActions: IVEConfig.roles.ADMIN.name,
                                                showAppToolbar: true,
                                                showAppToolbarInnovation: false,
                                                showNavigationDrawer: true,
                                                showAppFooter: false,
                                                showContentToolbar: false,
                                                showContentHeader: false,
                                                showContentFooter: true,
                                            },
                                        }
                                    ]
                                },
                            ]
                        },
                        {
                            path: "testing",
                            name: "Testing",
                            redirect: "testing/dialogs",
                            component: Testing,
                            meta: {
                                id: "admin-testing",
                                auth: {
                                    requiresAuth: true,
                                    acceptedRoles: [
                                        IVEConfig.roles.ADMIN.name
                                    ]
                                },
                                toolbarTitle: "Testing",
                                loadNavigationDrawer: IVEConfig.roles.ADMIN.name,
                                loadUserActions: IVEConfig.roles.ADMIN.name,
                                showAppToolbar: true,
                                showAppToolbarInnovation: false,
                                showNavigationDrawer: true,
                                showAppFooter: false,
                                showContentToolbar: false,
                                showContentHeader: false,
                                showContentFooter: true
                            },
                            children: [
                                {
                                    path: "dialogs",
                                    name: "DialogsTesting",
                                    component: DialogsTesting,
                                    meta: {
                                        id: "admin-testing-dialogs",
                                        auth: {
                                            requiresAuth: true,
                                            acceptedRoles: [
                                                IVEConfig.roles.ADMIN.name
                                            ]
                                        },
                                        toolbarTitle: "Talk with me",
                                        loadNavigationDrawer: IVEConfig.roles.ADMIN.name,
                                        loadUserActions: IVEConfig.roles.ADMIN.name,
                                        showAppToolbar: true,
                                        showAppToolbarInnovation: false,
                                        showNavigationDrawer: true,
                                        showAppFooter: false,
                                        showContentToolbar: false,
                                        showContentHeader: false,
                                        showContentFooter: false
                                    },
                                },

                            ]
                        },
                    ],
                },
                {
                    path: "approver",
                    name: "ApproverParent",
                    component: ApproverParent,
                    redirect: "approver/operationManagement",
                    meta: {
                        id: "approver-parent",
                        auth: {
                            requiresAuth: true,
                            acceptedRoles: [
                                IVEConfig.roles.ADMIN.name,
                                IVEConfig.roles.APPROVER_INNOVATION.name,
                            ]
                        },
                        toolbarTitle: "Approver",
                        loadNavigationDrawer: IVEConfig.roles.APPROVER_INNOVATION.name,
                        loadUserActions: IVEConfig.roles.APPROVER_INNOVATION.name,
                        showAppToolbar: true,
                        showAppToolbarInnovation: false,
                        showNavigationDrawer: true,
                        showAppFooter: false,
                        showContentToolbar: false,
                        showContentHeader: false,
                        showContentFooter: true
                    },
                    children: [
                        {
                            path: "operationManagement",
                            name: "ApproverManagement",
                            component: ApproverManagement,
                            meta: {
                                id: "approver-management",
                                auth: {
                                    requiresAuth: true,
                                    acceptedRoles: [
                                        IVEConfig.roles.APPROVER_INNOVATION.name,
                                        IVEConfig.roles.ADMIN.name
                                    ]
                                },
                                toolbarTitle: "Approver Operation Management",
                                loadNavigationDrawer: IVEConfig.roles.APPROVER_INNOVATION.name,
                                loadUserActions: IVEConfig.roles.APPROVER_INNOVATION.name,
                                showAppToolbar: true,
                                showAppToolbarInnovation: false,
                                showNavigationDrawer: true,
                                showAppFooter: false,
                                showContentToolbar: false,
                                showContentHeader: false,
                                showContentFooter: true
                            }
                        },
                        {
                            path: "contacts",
                            name: "GhostContactsTable",
                            component: GhostContactsTable,
                            meta: {
                                id: "ghost-contacts-table",
                                auth: {
                                    requiresAuth: true,
                                    acceptedRoles: [
                                        IVEConfig.roles.APPROVER_INNOVATION.name,
                                        IVEConfig.roles.ADMIN.name
                                    ]
                                },
                                toolbarTitle: "Contacts collected by ghost page",
                                loadNavigationDrawer: IVEConfig.roles.APPROVER_INNOVATION.name,
                                loadUserActions: IVEConfig.roles.APPROVER_INNOVATION.name,
                                showAppToolbar: true,
                                showAppToolbarInnovation: false,
                                showNavigationDrawer: true,
                                showAppFooter: false,
                                showContentToolbar: false,
                                showContentHeader: false,
                                showContentFooter: true
                            }
                        },

                    ]
                },
                {
                    path: "iadmin",
                    name: "OperationsHistoryParent",
                    component: OperationsHistoryParent,
                    redirect: "iadmin/OperationsHistoryParent",
                    meta: {
                        id: "oh-parent",
                        auth: {
                            requiresAuth: true,
                            acceptedRoles: [
                                IVEConfig.roles.ADMIN.name,
                                IVEConfig.roles.ADMIN_INNOVATION.name,
                            ]
                        },
                        toolbarTitle: "Operations History",
                        loadNavigationDrawer: IVEConfig.roles.ADMIN_INNOVATION.name,
                        loadUserActions: IVEConfig.roles.ADMIN_INNOVATION.name,
                        showAppToolbar: true,
                        showAppToolbarInnovation: false,
                        showNavigationDrawer: true,
                        showAppFooter: false,
                        showContentToolbar: false,
                        showContentHeader: false,
                        showContentFooter: true
                    },
                    children: [
                        {
                            path: "OperationsHistory",
                            name: "OperationsHistory",
                            component: OperationsHistory,
                            meta: {
                                id: "operations-history",
                                auth: {
                                    requiresAuth: true,
                                    acceptedRoles: [
                                        IVEConfig.roles.ADMIN_INNOVATION.name,
                                        IVEConfig.roles.ADMIN.name
                                    ]
                                },
                                toolbarTitle: "Startup Management Operations History",
                                loadNavigationDrawer: IVEConfig.roles.ADMIN_INNOVATION.name,
                                loadUserActions: IVEConfig.roles.ADMIN_INNOVATION.name,
                                showAppToolbar: true,
                                showAppToolbarInnovation: false,
                                showNavigationDrawer: true,
                                showAppFooter: false,
                                showContentToolbar: false,
                                showContentHeader: false,
                                showContentFooter: true
                            }
                        }
                    ]
                }
            ]
        }
    ];

    export default routes;
